import { render, staticRenderFns } from "./HistologColorToggle.vue?vue&type=template&id=7857733a&scoped=true"
import script from "./HistologColorToggle.vue?vue&type=script&lang=js"
export * from "./HistologColorToggle.vue?vue&type=script&lang=js"
import style0 from "./HistologColorToggle.vue?vue&type=style&index=0&id=7857733a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857733a",
  null
  
)

export default component.exports